import { FeedPerson, FeedRunCard } from "@signalist/shared-types";

import { ContactProspect } from "@/pages/Private/pages/Contacts/schema/contacts";

/**
 * Maps a card's tracked person to the `ContactProspect` preview that
 * `openContactLeadPanel` expects (D6) — the docked panel renders this
 * immediately while the full detail loads (GlobalSearchModal pattern).
 * Null when the person has no prospect (the panel cannot open, D6/D7).
 */
export const feedPersonToContactPreview = (
	person: FeedPerson,
	card: FeedRunCard
): ContactProspect | null => {
	if (!person.prospectId) {
		return null;
	}

	const [firstName, ...restOfName] = (person.name ?? "").split(" ").filter(Boolean);

	return {
		id: person.prospectId,
		name: person.name,
		firstName: firstName ?? null,
		lastName: restOfName.length > 0 ? restOfName.join(" ") : null,
		email: person.email,
		emailStatus: null,
		title: person.role,
		seniority: null,
		linkedinUrl: person.linkedinUrl,
		city: null,
		state: null,
		country: null,
		image: person.avatarUrl,
		phone: person.phone,
		phoneStatus: null,
		headline: person.headline,
		sentiment: null,
		gender: null,
		genderProbability: null,
		createdAt: null,
		updatedAt: null,
		organization: card.company.organizationId
			? ({
					id: card.company.organizationId,
					name: card.company.name ?? "",
					industry: card.company.industry,
					city: null,
					state: null,
					country: null,
					estimatedNumEmployees: card.company.employeeCount,
					websiteUrl: card.company.websiteUrl,
					primaryDomain: null,
					linkedinUrl: card.company.linkedinUrl,
					logoUrl: card.company.logoUrl,
					foundedYear: null,
				} as ContactProspect["organization"])
			: null,
		...(person.listPersonId
			? {
					listPersons: [{ id: person.listPersonId, listId: card.listId, updatedAt: card.runAt }],
					lists: [{ id: card.listId, name: card.listName ?? "" }],
				}
			: {}),
	};
};
